import { Mui } from "@osu/react-ui";
import { useBulkAssignUnassignApplicationsMutation } from "../../services/graphql/api";

export default function AssignmentAlert() {
    const [_, result] = useBulkAssignUnassignApplicationsMutation({ fixedCacheKey: "manage-applications-dialog" }); // eslint-disable-line
    const { data = {}, isUninitialized, isLoading, reset: resetApiResults } = result;

    // console.log("assignment result", data);
    
    if (isUninitialized || isLoading) { return <></>; }
    
    const isDetectedFailure = data.status !== "success";
    const color = isDetectedFailure ? "error" : "success";
    
    // TODO Should we split up successes and errors? Handling displaying may be difficult from an rtkq state perspective.
    let message = [data.successDetails, data.errorDetails].filter(o => o).flat()?.map(replaceDatetimeWithLocaleString).join("\r\n");
    if(!message) message = "Generic error occurred"
    
    const newLineCapable = { marginBottom: "1rem", marginTop: "1rem", whiteSpace: "pre-line" };
    
    return (
        <Mui.Alert color={color} sx={{ marginTop: "0.5em", width: "100%" }} onClose={resetApiResults}>
            <Mui.Typography sx={newLineCapable}>{message}</Mui.Typography>
        </Mui.Alert>
    );
}

function replaceDatetimeWithLocaleString(message) {
    const matches = message.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/g);

    if (!matches) { return message; }
    
    matches.forEach((match) => {
        const localeString = new Date(match).toLocaleString(); // Convert datetime to locale string
        message = message.replace(match, localeString);
    });

    return message;
}